import MuiDialog from 'components/MuiDialog';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const Complete = ({ isOpen, onClose }: Props) => (
  <MuiDialog.Confirm
    isOpen={isOpen}
    title="Гишүүнчлэлийн бүртгэлийн хүсэлт амжилттай боллоо"
    message="Баталгаажуулахад 1 хүртэлх хоног шаардагдана"
    onClose={onClose}
  />
);

export default Complete;
